import { PasswordReset } from 'dashboard/models/password-reset';
import Action from 'lib/interfaces/Action';

interface PasswordResetPayload {
  passwordReset: PasswordReset;
}

export type PasswordResetActions = Action<
  PasswordResetActionType.SavePasswordReset,
  PasswordResetPayload
>;

export enum PasswordResetActionType {
  SavePasswordReset = 'password-reset/SAVE_PASSWORD_RESET',
}

export function savePasswordReset(passwordReset: PasswordReset) {
  return {
    payload: {
      passwordReset,
    },
    type: PasswordResetActionType.SavePasswordReset,
  };
}
